import type { FC } from 'react';
import ContentLoader from 'react-content-loader';

import style from './style.scss';

const MatchDetailsPlaceholder: FC = () => (
  <>
    <div className={style.topBar}>
      <ContentLoader width={118} height={15} style={{ width: 118, height: 15 }}>
        <rect x={0} y={0} width={118} height={15} />
      </ContentLoader>
      <ContentLoader width={1} height={30} style={{ width: 1, height: 30 }}>
        <rect x={0} y={0} width={1} height={30} />
      </ContentLoader>
      <ContentLoader width={95} height={30} style={{ width: 95, height: 30 }}>
        <rect x={0} y={0} width={95} height={30} />
      </ContentLoader>
    </div>
    <div className={style.scorePart}>
      <ContentLoader width={175} height={85} style={{ width: 175, height: 85 }}>
        <rect x={0} y={0} width={48} height={15} />
        <circle cx={63} cy={8} r={8} />
        <circle cx={110} cy={8} r={8} />
        <rect x={126} y={0} width={48} height={15} />

        <rect x={28} y={25} width={119} height={15} />
        <rect x={40} y={55} width={95} height={30} />
      </ContentLoader>
    </div>
    <div className={style.videogamePart}>
      <ContentLoader width={330} height={15} style={{ width: 330, height: 15 }}>
        <rect x={0} y={0} width={15} height={15} />
        <rect x={30} y={0} width={300} height={15} />
      </ContentLoader>
    </div>
    <div className={style.contentPart}>
      <ContentLoader width={350} height={225} style={{ width: 330, height: 225 }}>
        <rect x={58} y={0} width={230} height={23} />
        <rect x={25} y={33} width={300} height={15} />
        <circle cx={93} cy={88} r={7} />
        <rect x={113} y={81} width={150} height={15} />
        <circle cx={93} cy={118} r={7} />
        <rect x={113} y={111} width={150} height={15} />
        <rect x={126} y={150} width={95} height={30} />
        <rect x={0} y={210} width={350} height={15} />
      </ContentLoader>
    </div>
  </>
);

MatchDetailsPlaceholder.displayName = 'MatchDetailsPlaceholder';

export default MatchDetailsPlaceholder;
